export default __webpack_public_path__ + "static/media/fondo-person-new.ed603415.png";